import { Theme, rem, radius, spacing, token } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';
import { tagName } from '../../helpers';

export const tag = tagName('tooltip');
const theme = new Theme(tag);

export const styles = [
  css`
    :where(.tooltip) {
      --offset: ${rem(8)};

      border: 0;
      margin: unset;
      max-inline-size: ${rem(400)};
      opacity: 0;
      overflow: visible;
      padding: unset;
      position: absolute;
      transition: opacity ${token('transition-duration-fast')};

      ${theme.props([
        ['padding', 'padding', spacing(100, 200)],
        ['border-radius', 'border-radius', radius('small')],
        [
          'background-color',
          'primary-background-color',
          token('albert-tooltip-background-default'),
        ],
        ['color', 'color', token('foreground-inverse')],
      ])}
    }

    :where(.arrow) {
      block-size: 8px;
      inline-size: 8px;
      position: absolute;
      transform: rotate(45deg);

      ${theme.props([
        [
          'background-color',
          'primary-background-color',
          token('albert-tooltip-background-default'),
        ],
      ])}
    }

    :host([variant='secondary']) :where(.tooltip) {
      ${theme.props([
        [
          'background-color',
          'secondary-background-color',
          token('albert-tooltip-background-secondary'),
        ],
      ])}

      &::after {
        border-color: ${token('albert-tooltip-background-secondary')};
      }
    }
    :host([variant='secondary']) :where(.arrow) {
      ${theme.props([
        [
          'background-color',
          'secondary-background-color',
          token('albert-tooltip-background-secondary'),
        ],
      ])}
    }

    :host([variant='tertiary']) :where(.tooltip) {
      border: ${rem(1)} solid ${token('border-subtle')};
      box-shadow: ${token('elevation-shadow-raised')};

      ${theme.props([
        [
          'background-color',
          'tertiary-background-color',
          token('albert-tooltip-background-tertiary'),
        ],
        [
          'color',
          'tertiary-color',
          token('albert-tooltip-foreground-tertiary'),
        ],
      ])}
    }

    :host([variant='tertiary']) :where(.arrow) {
      ${theme.props([
        [
          'background-color',
          'tertiary-background-color',
          token('albert-tooltip-background-tertiary'),
        ],
      ])}
    }

    :host([variant='error']) :where(.tooltip) {
      ${theme.props([
        [
          'background-color',
          'error-background-color',
          token('albert-tooltip-background-error'),
        ],
      ])}

      &::after {
        border-color: ${token('albert-tooltip-background-error')};
      }
    }
    :host([variant='error']) :where(.arrow) {
      ${theme.props([
        [
          'background-color',
          'error-background-color',
          token('albert-tooltip-background-error'),
        ],
      ])}
    }

    .tooltip:popover-open {
      opacity: 1;

      &[hide] {
        opacity: 0;
      }
    }

    @starting-style {
      .tooltip:popover-open {
        opacity: 0;
      }
    }

    .tooltip::before {
      content: '';
      display: block;
      position: absolute;
    }

    :host([placement='top']) .tooltip::before {
      block-size: var(--offset);
      inset-block-end: calc(-1 * var(--offset));
      inset-inline: 0;
    }

    :host([placement='bottom']) .tooltip::before {
      block-size: var(--offset);
      inset-block-start: calc(-1 * var(--offset));
      inset-inline: 0;
    }

    :host([placement='left']) .tooltip::before {
      inline-size: var(--offset);
      inset-block-end: 0;
      inset-block-start: 0;
      inset-inline-end: calc(-1 * var(--offset));
    }

    :host([placement='right']) .tooltip::before {
      inline-size: var(--offset);
      inset-block-end: 0;
      inset-block-start: 0;
      inset-inline-start: calc(-1 * var(--offset));
    }
  `,
];
